module.exports = __webpack_public_path__ + "static/bentonsans-extralight-webfont-47aec13ef2217ee78c16e5999a4c4fc5.woff2";